import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Main } from "./Main";
import { MenuItemsList } from "../Menu/MenuItemsList";

interface ILayoutProps {
	children: NonNullable<ReactNode>;
}

export const Layout = ({ children }: ILayoutProps) => {
	return (
		<>
			<div className="flex flex-col h-full">
				<Header />
				<div className="flex w-full h-full">
					<MenuItemsList />
					<Main>{children}</Main>
				</div>
				<Footer />
			</div>
		</>
	);
};
